<template>
<div class="h-screen flex overflow-hidden bg-cool-gray-100">
    <div class="">
      <div class="relative h-full max-w-screen-xl mx-auto">

      </div>
    </div>
  
    <div class="relative pt-2 pb-12 sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32 m-auto">


  
      <main class="mt-2 mx-auto max-w-screen-xl px-4 sm:mt-6 sm:px-6 md:mt-6 lg:mt-8 xl:mt-10">
        <div class="text-center items-center">
            <img src="../assets/logo.png" class="w-48  m-auto mb-6"  />
            <!-- <img  src="../../logo.png" class="w-64  m-auto"  /> -->
          <h2 class="text-4xl tracking-tight leading-10 font-bold  text-teal-600 sm:text-4xl sm:leading-none md:text-4xl">
            <br class="xl:hidden">
            <span class="text-4xl ">مـنصة صـحتنا الـرقمية </span>
          </h2>

        
          <p class=" text-2xl max-w-md   mx-auto   text-gray-500    ">
            تسجيل مرضى الأورام و ذوي الامراض المزمنة 
          </p>
      <dl
        
        class="

          my-12
          space-y-10
          sm:space-y-0 sm:grid sm:grid-cols-2 sm:col-gap-6 sm:row-gap-12
          lg:grid-cols-2 lg:col-gap-8
        "
      >
        <div class="col-span-2">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            اهداف المنصة
          </h3>
          <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-400">
          توفر منصة التالي:
          </p>
        </div>
        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-yellow-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              هدف 1#
            </dt>
          </div>
        </div>
        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-yellow-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              هدف 2#
            </dt>
          </div>
        </div>

        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-yellow-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              هدف 3#
            </dt>
          </div>
        </div>

        <div class="flex space-x-3 space-x-reverse">
          <!-- Heroicon name: check -->
          <svg
            class="flex-shrink-0 h-6 w-6 text-yellow-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <div class="space-y-2">
            <dt class="text-lg leading-6 font-medium text-gray-900">
              هدف 4#
            </dt>
          </div>
        </div>
      </dl>
          
          <div class="mt-4 w-full mx-auto sm:flex sm:justify-center md:mt-8">
            <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
            <router-link to="/signup" class="w-full flex items-center justify-center px-8 py-5 border border-transparent text-md leading-6 font-light rounded-md text-primary-800  bg-white hover:text-teal-500   focus:outline-none focus:border-teal-300 focus:shadow-outline-blue transition duration-150 ease-in-out md:py-4 md:text-2xl md:px-10">
               تـسجـيل كمريض
             </router-link>
            </div>
          </div>
            <div class="mt-2 w-full mx-auto sm:flex sm:justify-center md:mt-3">
            <div class="mt-2 rounded-md shadow sm:mt-0 sm:ml-3">
            <router-link to="/enquiry" class="w-full flex items-center justify-center px-8 py-5 border border-transparent text-sm leading-6 font-bold rounded-md text-white  bg-primary-500 hover:text-primary-800 hover:bg-primary-300 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out md:py-4 md:text-base md:px-10">
               الاستفسار عن حالة التسجيل   
             </router-link>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
};
</script>

<style scoped>


@keyframes ckw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
